export const openDoc = (url:string | URL, winParams = '') => {
  let windowObjectReference = null;
  windowObjectReference = window.open(
    url,
    'printwin',
    winParams,
  );
  windowObjectReference?.focus();
};
